import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {QuestionItemListComponent} from './components/question-item-list/question-item-list.component';
import {UserDataComponent} from './components/user-data/user-data.component';
import {BankamountComponent} from './components/bankamount/bankamount.component';
import {ConsentDeclarationComponent} from './pages/consent-declaration/consent-declaration.component';
import {CheckBirthdayValidationDirective} from './pages/identification/checkBirthdayValidation.directive';
import {CheckUuidValidationDirective} from './pages/identification/checkUuidValidation.directive';
import {IsRowOrColumnPipe} from './pipes/is-row-or-column.pipe';
import {FieldItemRowComponent} from './components/field-item-row/field-item-row.component';
import {IdentificationComponent} from './pages/identification/identification.component';
import {SuccessDialogComponent} from './dialogs/success-dialog/success-dialog.component'
import {TranslateModule} from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppearencePipe} from './pipes/appearence/appearence.pipe';
import {MaxFieldWidthPipe} from './pipes/max-field-width.pipe';

@NgModule({
   declarations: [
      IdentificationComponent,
      QuestionItemListComponent,
      UserDataComponent,
      BankamountComponent,
      ConsentDeclarationComponent,
      CheckUuidValidationDirective,
      CheckBirthdayValidationDirective,
      IsRowOrColumnPipe,
      FieldItemRowComponent,
      AppearencePipe,
      SuccessDialogComponent
   ],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      TranslateModule.forRoot(),
      BrowserAnimationsModule,
      MaxFieldWidthPipe
   ],
   exports: [
      IsRowOrColumnPipe,
      SharedModule
   ],
   providers: [
      DatePipe
   ],
   schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ProjectModule { }
